// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9nUd4","footer":"styles_footer__21yvY"};